import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import SelectableRow from '@/components/table/SelectableRow';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import MessageCell from '@/components/table/MessageCell';
import SimpleCell from '@/components/table/SimpleCell';
import MemberPermissionsDropdown from './MemberPermissionsDropdown';
import { permissionsGroup } from '../../helper';
import memberEntities from '../constants';
import MemberNameCell from './MemberNameCell';
import MemberDescriptionCell from './MemberDescriptionCell';

const MemberPermissionRow = ({
  allowAdd,
  allowRemove,
  allowSecure,
  className,
  entity,
  member,
  onChange,
  permissionGroups,
  removeMember,
}) => (
  <SelectableRow
    className={clsx('aridhia-member-permission-row', className)}
    error={member.archived}
    label={member.name}
    warning={[undefined, memberEntities.USER].includes(member.entity) && (!member.archived && !member.approved)}
  >
    <MemberNameCell member={member} />
    <MemberDescriptionCell member={member} />
    {member.entity === memberEntities.USERGROUP && (<MessageCell messageId="icon.usergroup" />)}
    {member.entity !== memberEntities.USERGROUP && (<SimpleCell content={member.role?.name || ''} />)}
    {allowSecure && (
    <Table.Cell collapsing colSpan={allowAdd && !allowRemove ? 3 : null}>
      <MemberPermissionsDropdown
        permissionGroups={permissionGroups}
        permission={permissionsGroup(member, permissionGroups)}
        entity={entity}
        onChange={(value) => onChange(member.uuid || member.code, value)}
        disabled={[undefined, memberEntities.USER].includes(member.entity) && (member.archived || !member.approved)}
      />
    </Table.Cell>
    )}
    {!allowSecure && (
      <MessageCell
        collapsing
        colSpan={allowAdd && !allowRemove ? 3 : null}
        messageId={`user.permission.${entity}.${permissionsGroup(member, permissionGroups).toLowerCase()}`}
      />
    )}
    {allowRemove && (
    <Table.Cell collapsing>
      <RowDeleteButton
        entity={`${entity}.member`}
        floated="right"
        onClick={() => removeMember(member.uuid || member.code)}
      />
    </Table.Cell>
    )}
  </SelectableRow>
);

export default MemberPermissionRow;
